import { render, staticRenderFns } from "./msElegDetails.vue?vue&type=template&id=0b7ab49a&scoped=true"
import script from "./msElegDetails.vue?vue&type=script&lang=js"
export * from "./msElegDetails.vue?vue&type=script&lang=js"
import style0 from "./msElegDetails.vue?vue&type=style&index=0&id=0b7ab49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ab49a",
  null
  
)

export default component.exports